/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Logo } from '@components/atoms'

import { grey } from '@mui/material/colors'

export const BoxInitEmptyView = () => {
	return (
		<View css={style}>
			<Logo
				className="accessControlInitLogo"
				showCompanyName={false}
				logoColor={grey[200]}
				imageStyle={{ width: '10rem', height: '10rem', marginRight: 0 }}
			/>
		</View>
	)
}

const style = css({
	position: 'relative',
	width: '100%',
	height: '100%',

	'.accessControlInitLogo': {
		position: 'absolute',
		zIndex: 0,
		top: 0,
		bottom: 0,
		margin: 'auto',
		right: 0,
		left: 0,
	},
})
